// Configuration & constants for the public incorporation request flow.

export const STORAGE_KEY = 'bimcorp_wizard_state_v1';
export const TOTAL_STEPS = 3;

// Maps a selected-package id to the route key used in PRICING / recommendation copy.
export const PACKAGE_TO_ROUTE = {
  'incorporate': 'startCorp',
  'full-launch': 'launchCorp',
  'corporate-compliance': 'runCorp',
  'special-project-structuring': 'customProject',
};

// Diagnostic answers automatically pre-filled when a package is chosen.
// IMPORTANT: only pre-fill "yes" for services the package CLEARLY includes.
// We deliberately do NOT pre-fill "no" — the user must answer those manually.
export const PACKAGE_DIAGNOSTIC_ANSWERS = {
  'full-launch':                  { rfcNeeded: 'yes', bankAccountNeeded: 'yes' },
  'corporate-compliance':         { rfcNeeded: 'yes', bankAccountNeeded: 'yes', governanceNeeded: 'yes' },
  // 'incorporate' includes only the legal formation — no service pre-fills.
  // 'special-project-structuring' is bespoke — no service pre-fills.
};

export const VALID_PACKAGE_SLUGS = Object.keys(PACKAGE_TO_ROUTE);

export const INITIAL_FORM_DATA = {
  knowsPackage: '',
  selectedPackage: '',
  whatBuilding: '',
  hasAddress: '',
  rfcNeeded: '',
  bankAccountNeeded: '',
  governanceNeeded: '',
  foreignParticipation: '',
  landRestrictedZone: '',
  taxIDs: '',
  fullName: '',
  email: '',
  phone: '',
  phoneCountryCode: '',
  country: '',
  preferredLanguage: 'English',
};

export const FILE_KEYS = []; // No file uploads in the public flow anymore.
